/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, Input } from '@angular/core';

@Component({
  selector: 'tgv-side-bar',
  standalone: false,
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css']
})
export class SideBarComponent  {
  @Input() title: string;
  @Input() hideButton = false;
  display = 'none';
  displayClassSideBar = 'backGroud-sidebar animate-right';
  displayClassBackGround = 'sidebar bar-block card animate-right';

  openRightMenu(): void {
    this.display = 'block';
    this.displayClassBackGround = 'bar-block backGroud-sidebar animate-right';
    this.displayClassSideBar = 'sidebar bar-block card animate-right';
  }

  closeRightMenu(): void {
    this.displayClassSideBar = 'sidebar bar-block card animate-right-close';
    this.displayClassBackGround = 'backGroud-sidebar animate-right-close';
  }
}
